import { diffComparisonType } from '@workalizer/shared/types';
import { calculateAverage, getInterval, getPercentageDiff, getPreviousPeriod, groupByPeriod, sumBy } from '@workalizer/shared/utils';
import { endOfDay, startOfDay } from 'date-fns';
var mockPeriodsData = [
    {
        userInternalSharing: 3,
        userExternalSharing: 2,
        teamInternalSharing: 4,
        teamExternalSharing: 3,
        previousInternalSharing: 2,
        previousExternalSharing: 1
    },
    {
        userInternalSharing: 2,
        userExternalSharing: 1,
        teamInternalSharing: 5,
        teamExternalSharing: 2,
        previousInternalSharing: 3,
        previousExternalSharing: 2
    },
    {
        userInternalSharing: 1,
        userExternalSharing: 2,
        teamInternalSharing: 6,
        teamExternalSharing: 4,
        previousInternalSharing: 2,
        previousExternalSharing: 1
    },
    {
        userInternalSharing: 1,
        userExternalSharing: 1,
        teamInternalSharing: 3,
        teamExternalSharing: 2,
        previousInternalSharing: 1,
        previousExternalSharing: 2
    },
    {
        userInternalSharing: 1,
        userExternalSharing: 1,
        teamInternalSharing: 4,
        teamExternalSharing: 3,
        previousInternalSharing: 2,
        previousExternalSharing: 1
    },
    {
        userInternalSharing: 2,
        userExternalSharing: 3,
        teamInternalSharing: 5,
        teamExternalSharing: 2,
        previousInternalSharing: 1,
        previousExternalSharing: 1
    }
];
var calculateTotals = function (periodsData) {
    var userInternalSharing = sumBy(periodsData, 'userInternalSharing');
    var userExternalSharing = sumBy(periodsData, 'userExternalSharing');
    var teamInternalSharing = sumBy(periodsData, 'teamInternalSharing');
    var teamExternalSharing = sumBy(periodsData, 'teamExternalSharing');
    var previousInternalSharing = sumBy(periodsData, 'previousInternalSharing');
    var previousExternalSharing = sumBy(periodsData, 'previousExternalSharing');
    var teamAvgInternal = calculateAverage(teamInternalSharing, periodsData.length);
    var teamAvgExternal = calculateAverage(teamExternalSharing, periodsData.length);
    var teamDiffInternal = getPercentageDiff(teamAvgInternal, userInternalSharing, { comparisonType: diffComparisonType.teamAverage });
    var teamDiffExternal = getPercentageDiff(teamAvgExternal, userExternalSharing, { comparisonType: diffComparisonType.teamAverage });
    return {
        userInternalSharing: userInternalSharing,
        userExternalSharing: userExternalSharing,
        teamInternalSharing: teamInternalSharing,
        teamExternalSharing: teamExternalSharing,
        previousInternalSharing: previousInternalSharing,
        previousExternalSharing: previousExternalSharing,
        teamDiffInternal: teamDiffInternal,
        teamDiffExternal: teamDiffExternal
    };
};
export var sharedFiles = function (input) {
    var interval = getInterval(input.dateFrom, input.dateTo);
    var _a = getPreviousPeriod(input.dateFrom, input.dateTo), prevPeriodDateFrom = _a.prevPeriodDateFrom, prevPeriodDateTo = _a.prevPeriodDateTo;
    var periods = groupByPeriod([], startOfDay(input.dateFrom), endOfDay(input.dateTo), interval);
    var previousPeriods = groupByPeriod([], startOfDay(prevPeriodDateFrom), endOfDay(prevPeriodDateTo), interval);
    var periodsData = periods.map(function (period, idx) {
        var _a, _b;
        var mockData = mockPeriodsData[idx % mockPeriodsData.length];
        var prevPeriod = previousPeriods[idx];
        if (input.userId === null) {
            return {
                period: period.date,
                previousPeriodLabel: (_a = prevPeriod === null || prevPeriod === void 0 ? void 0 : prevPeriod.date) !== null && _a !== void 0 ? _a : '',
                previousInternalSharing: mockData.previousInternalSharing,
                previousExternalSharing: mockData.previousExternalSharing,
                userInternalSharing: 0,
                userExternalSharing: 0,
                teamInternalSharing: mockData.teamInternalSharing,
                teamExternalSharing: mockData.teamExternalSharing
            };
        }
        return {
            period: period.date,
            previousPeriodLabel: (_b = prevPeriod === null || prevPeriod === void 0 ? void 0 : prevPeriod.date) !== null && _b !== void 0 ? _b : '',
            previousInternalSharing: mockData.previousInternalSharing,
            previousExternalSharing: mockData.previousExternalSharing,
            userInternalSharing: mockData.userInternalSharing,
            userExternalSharing: mockData.userExternalSharing,
            teamInternalSharing: mockData.teamInternalSharing,
            teamExternalSharing: mockData.teamExternalSharing
        };
    });
    var totals = calculateTotals(periodsData);
    return {
        totals: totals,
        periodsData: periodsData
    };
};
